// src/context/AuthContext.jsx
import { createContext, useContext, useState, useEffect } from "react";
import { apiRequest, clearAuthToken, getAuthToken, setAuthToken } from "../services/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(Boolean(getAuthToken()));

  useEffect(function() {
    if (!getAuthToken()) { setLoading(false); return; }
    apiRequest("/auth/user-me").then(function(result) {
      setUser(result.user); setProfile(result.user);
    }).catch(function() { clearAuthToken(); setUser(null); setProfile(null); }).finally(function() { setLoading(false); });
  }, []);

  async function register(email, password, fullName) {
    var result = await apiRequest("/auth/register", { method: "POST", body: JSON.stringify({ email, password, fullName }) });
    setAuthToken(result.token); setUser(result.user); setProfile(result.user); return result.user;
  }

  async function login(email, password) {
    var result = await apiRequest("/auth/user-login", { method: "POST", body: JSON.stringify({ email, password }) });
    setAuthToken(result.token); setUser(result.user); setProfile(result.user); return result.user;
  }

  async function logout() {
    clearAuthToken(); setUser(null); setProfile(null);
  }

  async function resetPassword(email) {
    await apiRequest("/auth/user-password-reset/request", { method: "POST", body: JSON.stringify({ email }) });
  }

  async function updateUserProfile(data) {
    if (!user) return;
    var result = await apiRequest("/auth/user-profile", { method: "PUT", body: JSON.stringify(data) });
    setProfile(function(prev) { return { ...prev, ...result.user }; });
  }

  return (
    <AuthContext.Provider value={{
      user, profile, loading,
      register, login, logout,
      resetPassword, updateUserProfile
    }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  var ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}
